/* eslint-disable */
import { QRCodeCanvas } from 'qrcode.react';
import React, { useMemo } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { Typography } from 'tfc-components';

import MainLayout from 'components/templates/MainLayout';
import { checkinQrcodeServiceV2 } from 'services/checkin';

const Congratulation: React.FC = () => {
  const { code } = useParams();
  const { data, error, isLoading } = useQuery(
    ['getInfoByCode', code],
    () => checkinQrcodeServiceV2(code || ''),
    {
      enabled: !!code
    }
  );

  const errorText = useMemo(() => {
    // const errorRes = error as any;
    // if (errorRes?.response?.data?.errors?.length > 0) {
    //   if (errorRes?.response?.data?.errors[0]?.code === 'checkinNotFound') {
    //     return (
    //       <>
    //         Quý nhân viên y tế chưa check-in.
    //         <br />
    //         Vui lòng check-in hoặc liên hệ với nhân viên Abbott để được hỗ trợ.
    //       </>
    //     )
    //   }
    // }

    const errorRes = (error as any)?.response?.data?.errors;
    if (errorRes && errorRes.length > 0) {
      const errorCode = errorRes[0]?.code;
      if (errorCode === 'CAMPAIGN_NOT_FOUND') {
        return (
          <>
            Chưa có chương trình diễn ra
          </>
        )
      }
    }
    return (
      <>
        Mã QR check-in của Quý nhân viên y tế
        <br />
        không hợp lệ
        <br />
        Vui lòng kiểm tra lại mã QR hoặc
        <br />
        liên hệ với nhân viên Abbott để được
        <br />
        hỗ trợ.
      </>
    )
  }, [error]);

  // const qrCode = 'https://ensure-surgery-event-2024-checkin.vercel.app/123';

  return (
    <MainLayout showHotline>
      {
        !isLoading && (
          <div className="p-congratulation">
            {
              error ? (
                <Typography.Text
                  textStyle="italic"
                  extendClasses="fs-26x36 p-congratulation_error"
                >
                  {errorText}
                </Typography.Text>
              ) : (
                <Typography.Text
                  textStyle="italic"
                  extendClasses="fs-26x36 p-register_confirmText"
                >
                  Cảm ơn Quý nhân viên y tế đã đăng
                  <br />
                  ký tham dự hội thảo. Tổng đài Abbott
                  <br />
                  sẽ gửi 1 tin nhắn có chứa đường link
                  <br />
                  mã QR check-in tới số điện thoại đã
                  <br />
                  đăng ký. Vui lòng cung cấp tin nhắn
                  <br />
                  cho nhân viên check-in để hoàn
                  <br />
                  thành thủ tục.
                </Typography.Text>
              )
            }
          </div>
        )
      }
      {
        data && code && !error && (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: '24px',
          }}
          >
            <div style={{
              backgroundColor: '#fff',
              padding: '16px',
              borderRadius: '12px',
              display: 'inline-flex',
            }}
            >
              <QRCodeCanvas
                value={code}
                size={256}
                level="H"
                marginSize={1}
                fgColor="#000000"
                bgColor="#FFFFFF"
              />
            </div>
            <Typography.Text
              extendClasses="fs-26x36 u-mt-8 p-congratulation_info"
              fontweight="600"
            >
              {data?.fullName}
            </Typography.Text>
          </div>
        )
      }
    </MainLayout>
  );
};

export default Congratulation;
